module.exports = __webpack_public_path__ + "static/img/333@3x.5a14a79a.png";